import { render, staticRenderFns } from "./AsientosComponent.vue?vue&type=template&id=72d1ae9b&scoped=true"
import script from "./AsientosComponent.vue?vue&type=script&lang=js"
export * from "./AsientosComponent.vue?vue&type=script&lang=js"
import style0 from "./AsientosComponent.vue?vue&type=style&index=0&id=72d1ae9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1ae9b",
  null
  
)

export default component.exports